import React, { useCallback, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainStoreBtn from '@atoms/btn/MainStoreBtn';
import NoticeBox from '@molecules/contents/NoticeBox';
import Card from '@molecules/contents/NoticePageBox';
import PcUniverse from '@organisms/main/partial/PcUniverse';
import { isMobileWithOutIpad } from '@helpers/EnvHelper';
import { useWindowSize } from 'usehooks-ts';
import MobileUniverse from '@organisms/main/mobile/partial/MobileUniverse';
import PartialNoticeBox from '@organisms/main/partial/PartialNoticeBox';

const SectionTopContents = () => {
  const { i18n, t } = useTranslation();
  const { communityStore } = useMobxStores();
  const navigate = useNavigate();
  const location = useLocation();
  let query = queryString.parse(location.search);
  const [onActiveIndex, setOnActiveIndex] = useState(0);

  const { width } = useWindowSize();
  let sectionStyle = {};
  if (width > 1920) {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/bg/bg_xhug_pc.png)',
      backgroundSize: '100%',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
    };
  } else {
    sectionStyle = {
      backgroundImage: 'url(/img/v2/main/bg/bg_pc_notice.png)',
      backgroundSize: '100%',
      backgroundPosition: 'top',
      backgroundRepeat: 'no-repeat',
    };
  }

  const getInitialData = useCallback(async () => {
    communityStore.setListQuery('noticeList', {
      lang: i18n.language,
      size: 3,
      page: 1,
    });
    await communityStore.getNoticeList();

    communityStore.setListQuery('eventList', {
      lang: i18n.language,
      size: 3,
      page: 1,
    });
    await communityStore.getEventList();

    return true;
  }, [communityStore, i18n.language]);

  useEffect(() => {
    getInitialData();
  }, [communityStore, getInitialData]);

  return (
    <div
      style={sectionStyle}
      className="relative pb-[10%] hug:pb-[37%] #md:!bg-cover"
    >
      <section className="max-w-[1200px] m-auto px-[15px] xs:px-[30px] ">
        <div className="w-full pt-[30px] text-center  sm:px-20">
          <MainStoreBtn />
        </div>
        <div className="grid grid-cols-2 gap-5 pt-[20%] lg:pt-[15%] hug:pt-[30%]">
          <div>
            <div className="w-full pl-3 font-bold xs:text-3xl text-xl mb-2 white-shadows">
              {t('공지사항')}
            </div>
            <PartialNoticeBox
              data={communityStore.noticeList.contents}
              type={'news'}
            />
          </div>

          <div>
            <div className="w-full pl-3 font-bold xs:text-3xl text-xl mb-2 white-shadows">
              {t('이벤트')}
            </div>

            <PartialNoticeBox
              data={communityStore.eventList.contents}
              type={'event'}
            />
          </div>
        </div>
        <div className="pt-[20%] sm:p-0"></div>
        {width > 640 ? <PcUniverse /> : <MobileUniverse />}
      </section>
      {width > 640 ? (
        <img
          src="/img/v2/main/universe/pc_universe_char.png"
          alt=""
          className="w-full  mt-[-75px] absolute hug:mt-[107px] xhug:mt-[100px]"
        />
      ) : (
        <div className="relative">
          <img
            src="/img/v2/main/universe_char.png"
            alt=""
            className="w-full mt-[-49px]"
          />
        </div>
      )}
    </div>
  );
};

export default observer(SectionTopContents);
